/* COH Glas-Konfigurator – englische Anzeige-Übersetzung.
   Wird nur eingebunden, wenn request.locale.iso_code == 'en'. Übersetzt ausschließlich die SICHTBARE Anzeige
   (Texte, aria-label, alt) im Konfigurator (#gc), in den Vertrauenszeilen (#gc-trust) und in Warenkorb-Elementen.
   Formularwerte (value) und Warenkorb-Eigenschaften bleiben bewusst deutsch, damit Auftragsabwicklung und Werkstatt unverändert arbeiten. */
(function () {
  'use strict';
  var PH = [
    ['Auf Wunsch verglasen wir die Fassung direkt mit Ihren Werten.', 'On request, we glaze the frame directly to your prescription.'],
    ['Randlose Fassungen verglasen wir als Maßanfertigung, mit Ihrer Glasform und Ihren Werten.', 'We glaze rimless frames as a made-to-measure service, with your lens shape and your prescription.'],
    ['Mit Gläsern bestellen', 'Order with lenses'],
    ['Einstärkengläser nach Ihren Werten, ab', 'Single-vision lenses to your prescription, from'],
    ['Custom Brillengläser ab', 'Custom-made lenses from'],
    ['Glasart', 'Lens type'],
    ['Standardglas 1,5', 'Standard lens 1.5'],
    ['Standardglas 1,6', 'Standard lens 1.6'],
    ['Standardglas', 'Standard lens'],
    ['Superentspiegelt, gehärtet, Lotusbeschichtet. Dünner und leichter.', 'Super anti-reflective, hardened, lotus coating. Thinner and lighter.'],
    ['Superentspiegelt, gehärtet, Lotusbeschichtet. Qualitativ höherwertiger als unsere Standardgläser, nach Maß für Ihre Fassung gefertigt.', 'Super anti-reflective, hardened, lotus coating. Higher quality than our standard lenses, made to measure for your frame.'],
    ['Superentspiegelt, gehärtet, Lotusbeschichtet', 'Super anti-reflective, hardened, lotus coating'],
    ['superentspiegelt', 'super anti-reflective'],
    ['Nach Muster gefärbt', 'Tinted to match a sample'],
    ['Angefertigtes Premium Glas 1,6, superentspiegelt, gehärtet, Lotusbeschichtet. Wir senden das Original-Glas Ihrer Fassung zum Färben ein, sodass die Farbe exakt übernommen wird.', 'Custom-made premium lens 1.6, super anti-reflective, hardened, lotus coating. We send the original lens of your frame in for tinting so that the colour is matched exactly.'],
    ['Angefertigtes Premium Glas 1,6', 'Custom-made premium lens 1.6'],
    ['Custom: Angefertigtes Premium Glas 1,6', 'Custom: custom-made premium lens 1.6'],
    ['Der Preis ist ein Pauschalpreis inklusive Tönung.', 'The price is a flat rate including tint.'],
    ['Gleitsichtgläser, Index über 1,6 oder Werte außerhalb der Auswahl', 'Progressive lenses, index above 1.6 or values outside the selection'],
    ['Index über 1,6 oder Werte außerhalb der Auswahl', 'Progressive lenses, index above 1.6 or values outside the selection'],
    ['Anfrage per WhatsApp', 'Enquire via WhatsApp'],
    ['Veredelung', 'Finishing'],
    ['Keine zusätzliche Veredelung', 'No additional finishing'],
    ['Blaulichtfilter', 'Blue light filter'],
    ['nur mit Standardglas 1,6', 'only with standard lens 1.6'],
    ['Selbsttönend (Transitions)', 'Photochromic (Transitions)'],
    ['Selbsttönend', 'Photochromic'],
    ['in Grau oder Braun', 'in grey or brown'],
    ['Ohne Tönung', 'No tint'],
    ['Klare Gläser', 'Clear lenses'],
    ['Alle Standard-, Sonder- und Duocolor-Farben ohne Aufpreis, hier wählen Sie die Intensität.', 'All standard, special and duo colours at no extra charge – here you choose the intensity.'],
    [', hier wählen Sie die Intensität frei.', ', here you can choose the intensity freely.'],
    ['Standardfarben', 'Standard colours'],
    ['Sonder- und Duocolor-Farben', 'Special and duo colours'],
    ['Sonderfarben', 'Special colours'],
    ['Duocolor-Tönung', 'duo colour tint'],
    ['Duocolor', 'Duo colour'],
    ['Tönungsfarbe', 'tint colour'],
    ['Tönungsstufe', 'tint level'],
    ['Tönung', 'Tint'],
    ['ab +', 'from +'],
    ['inklusive', 'included'],
    ['Intensität in Prozent', 'Intensity in percent'],
    ['Intensität der Duocolor-Tönung', 'Intensity of the duo colour tint'],
    ['Intensität', 'Intensity'],
    ['Bitte wählen Sie zuerst eine Farbe.', 'Please choose a colour first.'],
    ['Verlauf auf 0 %', 'Gradient to 0 %'],
    ['Verlauf 30 % auf 0 %', 'Gradient 30 % to 0 %'],
    ['Verlauf 65 % auf 0 %', 'Gradient 65 % to 0 %'],
    [' % auf 0 %', ' % to 0 %'],
    ['Verlauf', 'Gradient'],
    ['Vollton (durchgefärbt)', 'Solid tint (fully tinted)'],
    ['Vollton', 'Solid tint'],
    ['Frei wählbar von 20 bis 80 % in 10-%-Schritten.', 'Freely selectable from 20 to 80 % in 10 % steps.'],
    ['Bei Duocolor ist die untere Farbe immer 15 % schwächer als die obere. Die obere Farbe ist von 80 bis 30 % wählbar.', 'With duo colour, the lower colour is always 15 % lighter than the upper one. The upper colour can be chosen from 80 to 30 %.'],
    ['oben', 'top'],
    ['unten', 'bottom'],
    ['Farbabbildungen sind Muster des Glasherstellers und können je nach Bildschirm leicht abweichen.', 'Colour images are samples from the lens manufacturer and may differ slightly depending on your screen.'],
    ['Graugrün', 'Grey-green'], ['Nilgrün', 'Nile green'], ['Azurblau', 'Azure blue'], ['Pfefferminz', 'Peppermint'],
    ['Pastell Amethyst', 'Pastel Amethyst'], ['Pastell Lagune', 'Pastel Lagoon'], ['Pastell Rauch', 'Pastel Smoke'],
    ['Apfelcidre', 'Apple cider'], ['Lachs', 'Salmon'], ['Malve', 'Mauve'], ['Seegras', 'Seagrass'],
    ['Blau', 'Blue'], ['Braun', 'Brown'], ['Grau', 'Grey'], ['Grün', 'Green'],
    ['Ohne Sehstärke (Planglas)', 'Without prescription (plain lenses)'],
    ['ohne (Planglas)', 'none (plain lenses)'],
    ['Mit Sehstärke', 'With prescription'],
    ['mit Sehstärke', 'with prescription'],
    ['Sehstärke rechts', 'Prescription right'],
    ['Sehstärke links', 'Prescription left'],
    ['Sehstärke-Angaben', 'prescription details'],
    ['Sehstärke', 'Prescription'],
    ['Planglas', 'Plain lenses'],
    ['Sphäre rechts', 'Sphere right'], ['Sphäre links', 'Sphere left'],
    ['Zylinder rechts', 'Cylinder right'], ['Zylinder links', 'Cylinder left'],
    ['Achse rechts', 'Axis right'], ['Achse links', 'Axis left'],
    ['PD rechts', 'PD right'], ['PD links', 'PD left'],
    ['Sphäre', 'Sphere'], ['Zylinder', 'Cylinder'], ['Achse', 'Axis'], ['ACH', 'AX'],
    ['Wählen', 'Select'],
    ['Die Werte stehen auf Ihrem Brillenpass oder Rezept (SPH, CYL, ACH). Ist kein Zylinder angegeben, lassen Sie 0,00 stehen.', 'You will find the values on your glasses passport or prescription (SPH, CYL, AXIS). If no cylinder is given, leave 0.00.'],
    ['Pupillendistanz (PD)', 'Pupillary distance (PD)'],
    ['Pupillendistanz', 'pupillary distance'],
    ['PD unbekannt. Sie erhalten nach der Bestellung per E-Mail eine Messhilfe zum Ausdrucken und senden uns Ihre Werte einfach per Antwort.', 'PD unknown. After your order you will receive a printable measuring guide by e-mail and simply send us your values by replying.'],
    ['unbekannt, Messhilfe per E-Mail', 'unknown, measuring guide by e-mail'],
    ['PD unbekannt', 'PD unknown'],
    ['Sie können die', 'You can also download the'],
    ['PD-Messhilfe', 'PD measuring guide'],
    ['auch jetzt schon herunterladen.', 'right now.'],
    ['Ich willige ein, dass City Optikhaus meine Sehstärke-Angaben ausschließlich zur Anfertigung meiner Gläser verarbeitet.', 'I consent to City Optikhaus processing my prescription details solely for the production of my lenses.'],
    ['Mir ist bekannt, dass Gläser nach Maß vom Widerruf ausgeschlossen sind (§ 312 g Abs. 2 Nr. 1 BGB).', 'I am aware that made-to-measure lenses are excluded from the right of withdrawal (Section 312g (2) no. 1 of the German Civil Code, BGB).'],
    ['Glasform', 'Lens shape'],
    ['Originalform der Fassung', 'Original shape of the frame'],
    ['Wir fertigen die Gläser in der Form der Original-Gläser Ihrer Fassung.', 'We make the lenses in the shape of the original lenses of your frame.'],
    ['Angegeben ist die Glasbreite. Die Gesamtbreite der Fassung ergibt sich aus der Breite beider Gläser plus Stegbreite.', 'The lens width is shown. The overall width of the frame is the width of both lenses plus the bridge width.'],
    ['Ihre Wunschform ist nicht dabei? Es gibt unzählige weitere Formen, und jede Form können wir in der Größe individuell anpassen. Schreiben Sie uns gern per', 'Your preferred shape is not included? There are countless other shapes, and we can adjust the size of any shape individually. Feel free to message us via'],
    ['– das gilt auch bei allen anderen Fragen zu Ihren Gläsern.', '– this also applies to any other questions about your lenses.'],
    ['Zusatzoptionen', 'Additional options'],
    ['Cartier-Gravur', 'Cartier engraving'],
    ['Was ist das?', 'What is this?'],
    ['Sonderdicke', 'Special thickness'],
    ['Schmuckfacette', 'Decorative bevel'],
    ['beinhaltet immer Sonderdicke und Schmuckfacette', 'always includes special thickness and decorative bevel'],
    ['beinhaltet immer die Sonderdicke', 'always includes the special thickness'],
    ['Beispiel einer Cartier-Gravur im Glas', 'Example of a Cartier engraving in the lens'],
    ['Beispiel einer Schmuckfacette', 'Example of a decorative bevel'],
    ['Beispiel für Cut-outs', 'Example of cut-outs'],
    ['Auf Wunsch gravieren wir den Cartier-Schriftzug in Ihr Glas, dezent im oberen Bereich, so wie Sie es von den Originalgläsern kennen. Position und Größe richten sich nach der gewählten Glasform. Die Gravur verlängert die Lieferzeit auf ca. 30 Werktage.', 'On request, we engrave the Cartier lettering into your lens, discreetly in the upper area, just as you know it from the original lenses. Position and size depend on the chosen lens shape. The engraving extends the delivery time to approx. 30 working days.'],
    ['Unsere Standardgläser sind 1,8 mm dick. Mit der Sonderdicke fertigen wir Ihre Gläser in 3 mm. Die Sonderdicke ist die Grundlage für Schmuckfacette und Cut-outs und deshalb dort immer enthalten.', 'Our standard lenses are 1.8 mm thick. With the special thickness we make your lenses 3 mm thick. The special thickness is the basis for the decorative bevel and cut-outs and is therefore always included there.'],
    ['Bei der Schmuckfacette wird der Glasrand zusätzlich schräg angeschliffen und poliert. Dadurch bricht sich das Licht an der Kante, und Ihre randlose Fassung bekommt noch mehr Charakter. Benötigt die Sonderdicke (3 mm) und beinhaltet sie daher immer. Die Lieferzeit verlängert sich auf ca. 30 Werktage.', 'With the decorative bevel, the lens edge is additionally ground at an angle and polished. The light is refracted at the edge, giving your rimless frame even more character. It requires the special thickness (3 mm) and therefore always includes it. The delivery time extends to approx. 30 working days.'],
    ['Cut-outs sind gezielt ausgeschliffene Aussparungen am Glasrand, die Ihrer Fassung ein ganz individuelles Aussehen geben. Es gibt unzählige Varianten. Das Bild zeigt ein Beispiel, und diese Art fertigen wir. Wünschen Sie individuelle Cut-outs, schreiben Sie uns gern per', 'Cut-outs are deliberately ground recesses on the lens edge that give your frame a very individual look. There are countless variants. The picture shows an example, and this is the type we make. If you would like individual cut-outs, feel free to message us via'],
    ['. Cut-outs beinhalten immer Sonderdicke und Schmuckfacette, die Lieferzeit verlängert sich auf ca. 30 Werktage.', '. Cut-outs always include special thickness and decorative bevel; the delivery time extends to approx. 30 working days.'],
    ['Ihre Konfiguration (schematische Darstellung)', 'Your configuration (schematic illustration)'],
    ['Schematische Darstellung zur Orientierung. Sonderdicke, Schmuckfacette und Cut-outs werden nicht dargestellt. Farbton, Proportionen und Details können in der Fertigung abweichen.', 'Schematic illustration for guidance. Special thickness, decorative bevel and cut-outs are not shown. Shade, proportions and details may differ in production.'],
    ['Schematische Vorschau Ihrer Gläser', 'Schematic preview of your lenses'],
    ['Links: im Sonnenlicht (getönt). Rechts: drinnen (klar).', 'Left: in sunlight (tinted). Right: indoors (clear).'],
    ['Gesamt', 'Total'],
    ['Fassung', 'Frame'],
    ['Lieferzeit ca.', 'Delivery time approx.'],
    ['Lieferzeit', 'Delivery time'],
    ['Der Versand erfolgt gemeinsam, sobald alles fertig ist.', 'Everything ships together as soon as it is all ready.'],
    ['Hinweis', 'Note'],
    ['Original-Glas der Fassung wird zum Färben eingesendet', 'Original lens of the frame will be sent in for tinting'],
    ['Gläser nach Maß', 'made-to-measure lenses'],
    ['Gläser', 'Lenses'],
    ['Bitte wählen Sie die Glasform.', 'Please choose the lens shape.'],
    ['Bitte wählen Sie die Farbe der selbsttönenden Gläser (Grau oder Braun).', 'Please choose the colour of the photochromic lenses (grey or brown).'],
    ['Bitte wählen Sie eine Tönungsfarbe.', 'Please choose a tint colour.'],
    ['Bitte wählen Sie die Tönungsstufe.', 'Please choose the tint level.'],
    ['Bitte wählen Sie Vollton oder Verlauf und die Intensität.', 'Please choose a solid tint or gradient and the intensity.'],
    ['Bitte wählen Sie die Intensität der Duocolor-Tönung.', 'Please choose the intensity of the duo colour tint.'],
    ['Bitte geben Sie die Sphäre für beide Augen an.', 'Please enter the sphere for both eyes.'],
    ['Bitte geben Sie die Achse für das rechte Auge an.', 'Please enter the axis for the right eye.'],
    ['Bitte geben Sie die Achse für das linke Auge an.', 'Please enter the axis for the left eye.'],
    ['Bitte geben Sie die Pupillendistanz an oder markieren Sie „PD unbekannt“.', 'Please enter the pupillary distance or tick “PD unknown”.'],
    ['Bitte bestätigen Sie die Einwilligung zur Verarbeitung Ihrer Sehstärke-Angaben.', 'Please confirm your consent to the processing of your prescription details.'],
    ['Bitte bestätigen Sie den Hinweis zum Ausschluss des Widerrufsrechts bei Gläsern nach Maß.', 'Please confirm the notice that the right of withdrawal does not apply to made-to-measure lenses.'],
    ['Hallo, ich habe eine Anfrage zu Custom-Gläsern für', 'Hello, I have an enquiry about custom lenses for'],
    ['Hallo, ich habe eine Anfrage zu Gläsern für', 'Hello, I have an enquiry about lenses for'],
    ['Hallo, ich habe eine Frage zu Gläsern bzw. einer Sonderform für', 'Hello, I have a question about lenses or a special shape for'],
    ['Hallo, ich habe eine Frage zu Cut-outs für', 'Hello, I have a question about cut-outs for'],
    ['Hallo, ich habe eine Frage zu', 'Hello, I have a question about'],
    ['Fragen zu Ihren Gläsern? Schreiben Sie uns per', 'Questions about your lenses? Message us via'],
    ['Lieber persönlich? Termin im Store', 'Prefer to talk in person? Book an appointment at our store in'],
    ['oder', 'or'],
    ['Artikel', 'items']
  ];
  var L = 'A-Za-zÄÖÜäöüß';
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  PH.sort(function (a, b) { return b[0].length - a[0].length; });
  var RULES = PH.map(function (p) {
    var startsLetter = new RegExp('^[' + L + ']').test(p[0]);
    var endsLetter = new RegExp('[' + L + ']$').test(p[0]);
    var re = new RegExp((startsLetter ? '(^|[^' + L + '])' : '()') + esc(p[0]) + (endsLetter ? '(?![' + L + '])' : ''), 'g');
    return [re, '$1' + p[1].replace(/\$/g, '$$$$')];
  });
  var EXTRA = [
    [/(\d+(?:\s?[–-]\s?\d+)?) Werktage/g, '$1 working days']
  ];
  function tr(s) {
    if (!s || !/\S/.test(s)) return null;
    var lead = s.match(/^\s*/)[0], trail = s.match(/\s*$/)[0];
    var core = s.slice(lead.length, s.length - trail.length);
    var colon = '';
    if (/:$/.test(core) && core.length > 1) { colon = ':'; core = core.slice(0, -1); }
    var out = core, i;
    for (i = 0; i < RULES.length; i++) out = out.replace(RULES[i][0], RULES[i][1]);
    for (i = 0; i < EXTRA.length; i++) out = out.replace(EXTRA[i][0], EXTRA[i][1]);
    if (out.indexOf('€') === -1) out = out.replace(/(\d),(\d)/g, '$1.$2');
    if (out === core) return null;
    return lead + out + colon + trail;
  }
  window.GC_TR_EN = tr;

  var SEL = '#gc, #gc-trust, cart-item, cart-items, cart-drawer, cart-drawer-component, [class*="cart-drawer"], [class*="cart-item"], [class*="cart-line"]';
  var ATTRS = ['aria-label', 'alt', 'title', 'placeholder'];
  function run() {
    var roots = document.querySelectorAll(SEL), r, k;
    for (r = 0; r < roots.length; r++) {
      var root = roots[r];
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        var pn = n.parentNode && n.parentNode.nodeName;
        if (pn === 'SCRIPT' || pn === 'STYLE' || pn === 'TEXTAREA') continue;
        var t = tr(n.nodeValue);
        if (t !== null) n.nodeValue = t;
      }
      var els = root.querySelectorAll('[aria-label],[alt],[title],[placeholder]');
      for (k = 0; k < els.length; k++) {
        for (var a = 0; a < ATTRS.length; a++) {
          var v = els[k].getAttribute(ATTRS[a]);
          if (v) { var tv = tr(v); if (tv !== null) els[k].setAttribute(ATTRS[a], tv); }
        }
      }
    }
  }
  function fixLinks() {
    var as = document.querySelectorAll('#gc a[href], #gc-trust a[href]'), k, h, m, i, pre, d;
    for (k = 0; k < as.length; k++) {
      h = as[k].getAttribute('href') || '';
      if (/wa\.me/.test(h)) {
        m = h.match(/^([^?]*\?text=)(.*)$/);
        if (!m) continue;
        try { d = decodeURIComponent(m[2].replace(/\+/g, ' ')); } catch (e) { continue; }
        i = d.indexOf(': ');
        if (i < 0) continue;
        pre = tr(d.slice(0, i));
        if (pre !== null) as[k].setAttribute('href', m[1] + encodeURIComponent(pre + d.slice(i)));
      } else if (/^\/pages\//.test(h)) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (root !== '/') as[k].setAttribute('href', root.replace(/\/$/, '') + h);
      }
    }
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; try { run(); fixLinks(); } catch (e) { } }, 120);
  }
  function start() {
    run(); fixLinks();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
    setInterval(queue, 2000);
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
